import { uploadImageApi } from '@/api-calls/image/upload'
import { toast } from 'sonner'

export const onUpload = async (file: File): Promise<string> => {
  const formData = new FormData()
  formData.append('file', file)
  const apiCallFn = uploadImageApi.queryFn({ siteId: '123', formData })

  return new Promise<string>((resolve, reject) => {
    toast.promise(
      apiCallFn
        .then(async (response: any) => {
          // Successfully uploaded image
          console.log('response', response)
          const { url, signedUrl } = response

          // preload the image
          const image = new Image()
          image.src = url
          image.onload = () => {
            resolve(url)
          }
        })
        .catch(async (e: Error) => {
          reject(e)
          return e.message
        }),
      {
        loading: 'Uploading image...',
        success: 'Image uploaded successfully.',
        error: (e: Error) => {
          reject(e)
          return e.message
        },
      },
    )
  })
}

export const onValidate = (file: File) => {
  // Check if it's an image file
  if (!file.type.includes('image/')) {
    toast.error('File type not supported. Please upload an image file.')
    return false
  }

  // Check for HEIF/HEIC files specifically
  if (
    file.type.includes('heif') ||
    file.type.includes('heic') ||
    file.name.toLowerCase().endsWith('.heic') ||
    file.name.toLowerCase().endsWith('.heif')
  ) {
    toast.error(
      'HEIF/HEIC format is not supported. Please convert your image to JPEG, PNG, or WebP format before uploading.',
    )
    return false
  }

  // Check for supported formats
  const supportedFormats = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/tiff',
  ]
  if (!supportedFormats.includes(file.type)) {
    toast.error(
      'Unsupported image format. Please use JPEG, PNG, WebP, GIF, or TIFF format.',
    )
    return false
  }

  // Check file size
  if (file.size / 1024 / 1024 > 20) {
    toast.error('File size too big (max 20MB).')
    return false
  }

  return true
}
